import React, { useState, useEffect, useContext } from "react";
import { useHistory } from 'react-router-dom';
import Sales, { ISales } from "../../services/api/Sales";
import Year, { IYear } from "../../services/api/Year";
import Month, { IMonth } from "../../services/api/Month";
import Select from "../../components/Form/Select";
import Form from "./components/Form";
import { RouteProps, useParams } from "react-router";
import ContentHeader from "../../components/ContentHeader";
import { ReactComponent as SalesLogo } from "../../components/ContentHeader/assets/images/sales.svg";
import ItemBox from "../../components/ItemBox";
import BtnBack from "./components/BtnBack";
import Loading from "../../components/Loading";

import "../../components/assets/css/details.css";
import AuthContext from "../../contexts/AuthContext";

interface UnitDetailsProps {
  GroupId: Number;
  MonthId: Number;
  CurrentYear: Number;
}

const UnitDetails: React.FC<UnitDetailsProps> = () => {
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const [sale, setSale] = useState<ISales | null>(null);
  const [years, setYears] = useState<IYear[]>([]);
  const [months, setMonths] = useState<IMonth[]>([]);
  const [loading, isLoading] = useState<Boolean>(true);

  let { groupId, monthId, currentYear } = useParams<{
    groupId: string;
    monthId: string;
    currentYear: string;
  }>();

  if(user!.profile.name === "Sender"){
    const date = new Date();
    monthId = (date.getMonth()+1)+"";
  }

  async function LoadSales(group: Number, year: Number, month: Number) {
    const response: ISales = await Sales.Get(group, year, month);
    setSale(response);
  }

    useEffect(() => {
      isLoading(true);
      Promise.all([Year.GetAll(), Month.GetAll()])
      .then((value) => {
          setYears(value[0].filter((value) => { return value.active }));
        setMonths(value[1]);
      })
      .catch(console.log);
    }, []);

    useEffect(() => {
      if (months.length > 0) {
        isLoading(true);
        LoadSales(Number(groupId), Number(currentYear), Number(monthId));
      }
    }, [currentYear, groupId, monthId, months]);

    useEffect(() => {
        isLoading(false);
    }, [sale]);

  function list(obj: any): any {
    return { value: obj.id, label: obj.name };
  }

  return (
    <main className="wrapperApp">
      <ContentHeader
        title="Sales Update — Details"
        Icon={SalesLogo}
        breadcrumb={["Sales Update", "Details"]}
      />
      <div id="content">
        <section className="content__block">
          {loading ? (
            <Loading />
          ) : (
            <React.Fragment>
              <div className="content__header">
                <h2 className="content__title">UNIT DETAILS</h2>

                <div className="multi-selects">
                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="month"
                      title="Month"
                      options={months.map(list)}
                      value={monthId}
                      disabled={user!.profile.name === "Sender"}
                      handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
                          history.push("/sales-update/" + groupId + "/" + currentYear + "/" + event.currentTarget.value);
                      }}
                    />
                  </div>

                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="year"
                      title="Year"
                      options={years.map((obj) => { return { value: obj.name, label: obj.name } })}
                      value={currentYear}
                      disabled={user!.profile.name === "Sender"}
                      handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
                        history.push("/sales-update/" + groupId + "/" + event.currentTarget.value + "/" + monthId);
                      }}
                    />
                  </div>
                </div>
              </div>
              {!sale ? null : (
                <React.Fragment>
                  <div className="details">
                    <div className="details__top">
                      <BtnBack />
                      <ItemBox name={sale.groupName + " - " + sale.groupCode} />
                    </div>
                    <Form
                      sale={sale}
                      month={Number(monthId)}
                      year={Number(currentYear)}
                    />
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </section>
      </div>
    </main>
  );
};

export default UnitDetails;
